<template>
  <div>
    <div v-if="!isMinView" class="footer_box">
      <div class="footer main_width m_0">
        <div class="f_list">
          <ul class="f_ul f_ul_1">
            <li class="f_title">关于我们</li>
            <li class="f_li"><router-link class="href_li" to="/about?type=synopsis">企业简介</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/about?type=develop">发展历程</router-link></li>
          </ul>
        </div>
        <div class="f_list">
          <ul class="f_ul f_ul_2">
            <li class="f_title">产品与服务</li>
            <li class="f_li"><router-link class="href_li" to="/QXB">汽修宝（APP版 / PC版）</router-link></li>
            <!-- <li class="f_li"><router-link class="href_li" to="/businessCooperation?type=query">横向件产品查询系统</router-link></li> -->
            <li class="f_li"><router-link class="href_li" to="/cloudWarehouse">汽配云仓系统</router-link></li>
            <!-- <li class="f_li"><router-link class="href_li" to="/businessCooperation?type=market">配件查询/销售系统</router-link></li> -->
            <li class="f_li"><router-link class="href_li" to="/dockingService">API数据对接服务</router-link></li>
          </ul>
        </div>
        <div class="f_list">
          <ul class="f_ul f_ul_3">
            <li class="f_title">API数据对接服务</li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=VIN">VIN车架号接口</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=EPC">EPC结构图接口</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=OEM">OEM查询接口</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=Original">原厂数据接口</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=Maintain">维修保养记录接口</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=Danger">出险记录接口</router-link></li>
            <li class="f_li"><router-link class="href_li" to="/productService?type=Vehicle">车辆状况查询接口</router-link></li>
          </ul>
        </div>
        <div class="f_list">
          <ul class="f_ul f_ul_4 tes">
            <li class="f_title f_title1">广州前实网络科技有限公司</li>
            <li class="f_li">电话: 020-36328593</li>
            <li class="f_li">邮箱: qianshi@qxbapp.com</li>
            <li class="f_li">地址: 广东广州市白云区云城西路888号白云绿地中心40楼</li>
            <!-- <li class="f_li">Copyright © 2019汽修宝 <span @click="beian">粤ICP备16004731号-1</span></li>
            <li class="f_li">
              <img class="beian-icon" src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="">
              <span @click="beian2">粤公网安备44011102483911号</span>
            </li> -->
            <li class="f_img">
              <div class="f_img_box">
                <img class="f_img_box_img" src="/static/images2/app.png" alt="汽修宝app">
                <div class="img_text img_text1">下载汽修宝app</div>
                <img src="/static/images2/product_services.png" alt="汽修宝公众号">
                <div class="img_text">关注汽修宝公众号</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="beian_box main_width m_0">
        <a href="https://beian.miit.gov.cn/" target="_blank">Copyright © 2019汽修宝 粤ICP备16004731号-1</a>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483911" target="_blank">粤公网安备44011102483911号</a>
      </div>
    </div>
    <div v-else class="h5_footer_box">
      <div v-for="(item, index) in accordionData" :key="index" class="accordion-item">
        <div class="accordion-header" @click="toggle(index)">
          {{ item.title }}
          <img class="arrow" v-if="activeIndex === index" src="/static/images2/h5/go2.png" alt="">
          <img class="arrow" v-else src="/static/images2/h5/go1.png" alt="">
        </div>
        <transition name="slide">
          <div v-show="activeIndex === index" class="accordion-body">
            <ul>
              <li v-for="(content, i) in item.content" :key="i"><router-link :to="content.href">{{ content.title }}</router-link></li>
            </ul>
          </div>
        </transition>
      </div>
      <div class="info_box">
        <div class="info">
          <div class="company">广州前实网络科技有限公司</div>
          <div>电话: 020-363228593</div>
          <div>邮箱: qianshi@qxbapp.com</div>
          <div>地址: 广东广州市白云区云城西路888号白云绿地中心40楼</div>
        </div>
        <div class="h5_img">
          <div>
            <img class="" src="/static/images2/app.png" alt="汽修宝app">
            <div class=" img_text1">下载汽修宝app</div>
          </div>
          <div>
            <img src="/static/images2/product_services.png" alt="汽修宝公众号">
            <div class="">关注汽修宝公众号</div>
          </div>
        </div>
        <div class="h5_beian_box">
          <a href="https://beian.miit.gov.cn/" target="_blank">Copyright © 2019汽修宝 粤ICP备16004731号-1</a>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483911" target="_blank">粤公网安备44011102483911号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isMinView } from '../utils/index.js'
  export default {
    data(){
      return{
        isMinView: isMinView(),
        activeIndex: null, // 当前展开的面板索引
        accordionData: [
          {
            title: '关于我们',
            content: [{
              title: '企业简介',
              href: '/about?type=synopsis'
            }, {
              title: '发展历程',
              href: '/about?type=develop'
            }]
          },
          {
            title: '产品与服务',
            content: [{
              title: '汽修宝（APP版 / PC版）',
              href: '/QXB'
            }, {
              title: '汽配云仓系统',
              href: '/cloudWarehouse'
            }, {
              title: 'API数据对接服务',
              href: '/dockingService'
            }]
          },
          {
            title: 'API数据对接服务',
            content: [{
              title: 'VIN车架号接口',
              href: '/productService?type=VIN'
            }, {
              title: 'EPC结构图接口',
              href: '/productService?type=EPC'
            }, {
              title: 'OEM查询接口',
              href: '/productService?type=OEM'
            }, {
              title: '原厂数据接口',
              href: '/productService?type=Original'
            }, {
              title: '维修保养记录接口',
              href: '/productService?type=Maintain'
            }, {
              title: '出险记录接口',
              href: '/productService?type=Danger'
            }, {
              title: '车辆状况查询接口',
              href: '/productService?type=Vehicle'
            }]
          }
        ]
      }
    },
    components:{

    },
    created(){

    },
    mounted(){

    },
    methods:{
        beian(){
            window.open('https://beian.miit.gov.cn/')
        },
        beian2(){
            window.open('https://beian.mps.gov.cn/#/query/webSearch?code=44011102483911')
        },
        toggle(index) {
          this.activeIndex = this.activeIndex === index ? null : index;
        }
    }
  }
</script>

<style lang="less" scoped>
@import "../assets/style/utils.less";
.footer_box{
  background: #252B31;
  color: #FFFFFF;
  font-size: .px2vw(14)[@result];
  .footer{
    height: .px2vw(366)[@result];
    width: .px2vw(1280)[@result];
    padding-top: .px2vw(40)[@result];
    box-sizing: border-box;
    .f_list{
      float: left;
      text-align: left;
      .f_ul{
        .f_title{
          font-size: .px2vw(18)[@result];
          margin-bottom: .px2vw(16)[@result];
          font-weight: 700;
        }
        .f_title1 {
          margin-bottom: .px2vw(24)[@result];
        }
        .f_li{
          margin-bottom: .px2vw(12)[@result];
          cursor: pointer;
          line-height: .px2vw(22)[@result];
        }
        .f_li:hover{
          text-decoration: underline;
        }
      }
      .tes{
        cursor: auto;
        .f_li:hover{
          text-decoration: none;
        }
        .f_li{
          cursor: auto;
          text-decoration: none;
          span:hover{
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
      .f_ul_1{
        margin-right: .px2vw(200)[@result];
      }
      .f_ul_2{
        margin-right: .px2vw(50)[@result];
      }
      .f_ul_3{
        margin-right: .px2vw(160)[@result];
      }
      .f_ul_4{
        .f_img{
          margin-top: .px2vw(24)[@result];
          .f_img_box{
            display: flex;
            align-items: center;
            img{
              width: .px2vw(100)[@result];
              height: .px2vw(100)[@result];
              margin-right: .px2vw(16)[@result];
            }
            .img_text1{
              margin-right: .px2vw(64)[@result];
            }
          }
        }
      }
    }
  }
  .beian_box {
    padding-bottom: .px2vw(24)[@result];
    width: .px2vw(1280)[@result];
    a:nth-child(1) {
      margin-right: .px2vw(206)[@result];
    }
  }
}
@media screen and (max-width: 900px) {
  .h5_footer_box {
    padding: 0 .h5px2vw(24)[@result];
    background: #252B31;
    color: #FFFFFF;
    font-size: .h5px2vw(28)[@result];

    .accordion-header {
      padding: .h5px2vw(30)[@result] 0;
      border-bottom: .h5px2vw(1)[@result] solid #eaeaea;
      cursor: pointer;
      font-weight: 700;
      position: relative;
      display: flex;
      align-items: center;
      .arrow {
        width: .h5px2vw(24)[@result];
        height: .h5px2vw(24)[@result];
        margin-left: .h5px2vw(8)[@result];
        transition: transform 0.3s ease;
      }
    }
    .accordion-body {
      overflow: hidden;
      ul {
        list-style-type: none;
        margin: 0;
        li {
          padding: .h5px2vw(30)[@result] 0;
        }
      }
    }
    .slide-enter-active,
    .slide-leave-active {
      transition: max-height 0.3s ease-out;
      max-height: 400px; /* 初始最大高度 */
      overflow: hidden;
    }
    .slide-enter,
    .slide-leave-to {
      max-height: 0;
    }

    .info_box {
      padding: .h5px2vw(32)[@result] 0;
      font-size: .h5px2vw(24)[@result];
      .info {
        & > div {
          margin-bottom: .h5px2vw(16)[@result];
        }
        .company {
          font-weight: 700;
          font-size: .h5px2vw(28)[@result];
        }
      }
      .h5_img {
        padding: .h5px2vw(16)[@result] 0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin-bottom: .h5px2vw(106)[@result];
        & > div {
          margin: 0 .h5px2vw(24)[@result];
          img {
            width: .h5px2vw(240)[@result];
            height: .h5px2vw(240)[@result];
            margin-bottom: .h5px2vw(16)[@result];
          }
        }
      }
      .h5_beian_box {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        font-size: .h5px2vw(20)[@result];
        font-weight: 400;
        a:nth-child(1) {
          margin-bottom: .h5px2vw(16)[@result];
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue